import React, { Component } from 'react'
import './style.css'
import { Query } from "react-apollo";
import gql from "graphql-tag";
import UsersList from "../../containers/users/List"
import UserDetails from "../../containers/users/Details"

const QUERY = gql`
query getUsers($filter: userFilter) {
  users (filter: $filter) {
    id
    _id
    first_name
    last_name
    email
    phone_number
    unique_id
    role
    tutors {
      id
      _id
      state
    }
    clients {
      id
      _id
      state
    }
  }
}
`

class Users extends Component {
  render() {

    console.log(this.props)

    return (
      <React.Fragment>

        <div className="messages-container">

          <div className="messages-list">
            <Query
                query={QUERY}
                variables={{
                  filter: {role: this.props.match.params.role}
                }}
                >
                {({ loading, error, data, fetchMore }) => {
                if (loading) return <p>Loading...</p>;
                if (error) {
                  console.error(error)
                  return <p>Error :(</p>
                };

                if (!data || !data.users) return null

                return <UsersList
                    users={data.users}
                    active={this.props.match.params.uuid}
                  /> 

                }}
            </Query>
          </div>

          <div className="details-section">
            <UserDetails uuid={this.props.match.params.uuid} />
          </div>

        </div>

        
    </React.Fragment>
      
    );
  }
}

export default Users;



// WEBPACK FOOTER //
// ./src/views/Users/index.js